export default __webpack_public_path__ + "static/16-d5b772a6ec8fb43c8443c1bac9ab056a.png";